<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">支付问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions current">海星点计费说明</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>海星点计费说明</div>
            </div>
            <div class="answer">
              <br />2人民币1海星点 <br />普通线路2点/小时 <br />高配线路2点/小时
              <br />4090线路3点/小时
              <br />
              <br />（1）海星点与赠点均可在海星云云电脑使用
              <br />（2）海星点主账户转赠他人账户,其他账户收到的海星点,均为赠点
              <br />
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>说明</div>
            </div>
            <div class="answer">
              海星云电脑按照本说明的规定基于互联网充值服务（以下称“充值服务”），为获得充值服务，服务使用人（以下称“用户”）同意本说明的全部条款并按照页面上的提示完成全部的充值程序。
              用户在使用海星云电脑提供的各项服务之前，请您认真阅读并充分知悉、理解海星云电脑的各项规则及要求，尤其是与您息息相关的特别提示部分，以及国家关于该类互联网信息服务的法律法规等。
              如果您对本说明的任何条款表示异议，您可以选择不使用海星云软件；如果您在进行充值程序过程中使用充值服务即表示用户完全接受本说明下的全部条款，使用则意味着您将同意遵守本协议下条款，并认可我们后续可能对服务说明所作的调整。
              特别提示：
              请确认您具有完全民事行为能力，即您已年满18周岁，或您已年满16周岁且依靠自己的劳动收入作为主要生活来源。
              未成年用户使用海星云电脑充值服务，必须得到家长或其他监护人的同意，请未成年人用户监护人切实履行其监护义务。
              <br />●“海星点”是海星云电脑向您提供的用于在海星云电脑提供的产品或服务上进行相关消费的虚拟货币，但是“海星点”不能兑换为人民币或其他货币，您应该根据自身实际需求购买相应“海星点”。
              <br />●“海星赠点”是海星云电脑向您提供的用于在海星云电脑提供的产品或服务上进行相关消费的虚拟货币，“海星赠点”不可主动充值获得，“海星赠点”获得方式由官方赠送，官方补偿，官方附加充值活动，其他用户赠送等形势获得。
              <br />●海星点与赠点均可在海星云电脑使用；海星点主账户转赠他人账户,其他账户收到的海星点,均为赠点
              <br />●海星云赠点有效期为1年，充值后赠点可长期有效。
              <br />●海星云平台上的转账功能仅限于使用海星点账户中的点数，赠点账户点数无法转赠他人。同时，转账的点数视为赠送点数，进入对方的赠点账户。
              <br />●用户理解并同意，转账产品虚拟货币不适用无理由退换，转账一旦成功，即确定完成转赠，星瀛科技将不提供任何更改、修正服务。
              <br />●当用户在本平台进行转账时，用户必须仔细确认转赠的账号及信息，若因为用户自身操作不当、不了解或未充分了解转账说明等因素造成赠错账号、错填赠送点数等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
              <br />●海星云【邀请提现】活动中邀请用户获得的提现金额由被邀请充值用户转赠而得，即充值用户中海星点账户属提现金额部分，其对应的海星点数转到充值用户的赠点账户中（2元=1海星点）。
              <br />●周卡计时方式：在激活到账的7天内拥有95小时的自由使用时长，可使用的时间段为周一到周五0点到19点之间，其他时间段无法使用。（法定节假日均可使用）
              <br />●周卡售价：海星云周卡59元/张（V0及以上均可购买），购买后立即生效，一周有效期。
              <br />● 月卡计时方式：
              在激活到账的30天内拥有418小时的自由使用时长，可使用的时间段为周一到周五0点到19点之间，其他时间段无法使用。（法定节假日均可使用）
              <br />●
              月卡售价：海星云周卡168元/张（V0及以上均可购买），购买后立即生效，一月有效期。
              <br />●
              每人每次仅限购买1张，如需再次购买，需前一张时长卡（周卡或月卡）使用完毕。
              <br />● 超出时长卡使用的时间部分，按海星点扣费，下机自动结算。
              <br />● 时长卡不可转赠。 <br />●
              时长卡仅限普通机型线路使用，其他线路按正常海星点扣费。 <br />●
              时长卡售出后概不退换，最终解释权归海星云电脑所有。 <br />●
              “海星点”属于在线交付的充值类商品，因其特殊属性不适用《消费者权益保护法》中有关反悔权及网络购买商品七日无理由退货等条款的约束，用户一旦充值成功，充值即确定完成，海星云电脑不提供任何退还或逆向兑换服务。
              <br />● ”时长卡”
              属于在线交付的充值类商品，因其特殊属性不适用《消费者权益保护法》中有关反悔权及网络购买商品七日无理由退货等条款的约束，用户一旦充值成功，充值即确定完成，海星云电脑不提供任何退还或逆向兑换服务。
              <br />●
              用户进行充值后，应保留充值订单号以作为今后发生的支付投诉核对依据凭证（用户就充值服务投诉、但未有其他有效凭证佐证的，海星云电脑将不会做出补偿或赔偿）。
              <br />●
              当用户在本平台进行充值时，用户必须仔细确认自己的账号及信息，若因为用户自身操作不当、不了解或未充分了解充值计费方式等因素造成充错账号、
              错选充值种类等情形而损害自身权益，
              不得因此要求星瀛科技作任何补偿或赔偿。
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./Pay')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/pay/haixinclone.vue